import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useDispatch, useSelector } from 'react-redux'
import { CourseItem } from './CourseItem'
import { removeCourse, sortCourses } from '@/reducers/courses'
import { hasNatrualScience } from '@/utils/helpers'
import { AppDispatch, AppState, ICourse } from '@/types'
import { Text } from '@/components/UI'
import { removeGrade } from '@/reducers/grades'

type Props = {
    courses: ICourse[]
}

/**
 * Component for displaying list of courses
 */
export function CourseList({ courses }: Props) {
    const twentythreeFiveRule = useSelector((state: AppState) => state.grades.twentythreeFiveRule);
    const grades = useSelector((state: AppState) => state.grades.grades);

    const dispatch = useDispatch<AppDispatch>()

    const moveGrade = (dragIndex: number, hoverIndex: number) => {
        dispatch(sortCourses(dragIndex, hoverIndex))
    }


    return (
        <ul className="w-full flex flex-col animate-reveal">
            <li className="karakterkalkulator_course_header flex pb-1 px-1 border-b pt-4 sticky bg-sonans-new-light-gray top-[96px] sm:top-[128px] md:top-[103px] 3xl:top-[127px] z-30 border-sonans-new-black font-bold items-center" style={{ backgroundColor: 'rgba(0, 8, 25, 0.04)', zIndex: 30, position: 'sticky', top: '39px' }}>
                <span style={{ flex: 1 }}>Fag</span>
                <div style={{ display: 'flex', justifyContent: 'space-between', flex: 2, alignItems: 'center' }}>
                    <span className="w-[160px] xs:w-[200px] sm:w-[250px]" style={{ textAlign: 'center', flexShrink: 0 }}>Karakter</span>
                    <span style={{ width: '2.25rem', flexShrink: 0 }}></span>
                    <span>Slett</span>
                </div>
            </li>

            <DndProvider backend={HTML5Backend}>
                {courses.map((course, index) => (
                    <CourseItem
                        moveGrade={moveGrade}
                        id={course.id}
                        index={index}
                        key={course.id}
                        disabled={
                            (twentythreeFiveRule &&
                                !course.twentythreeFiveRule &&
                                !course.sciencePoints) ||
                            hasNatrualScience(course, grades)
                        }
                        onRemoveCourse={() => {
                            dispatch(removeCourse(course))
                            dispatch(removeGrade(course))
                        }}
                        course={course}
                    />
                ))}
            </DndProvider>
        </ul>
    )
}
